/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbPcs_vipUserRelationship$ref = any;
export type PdpRespSidebarBlurbs_vipUserRelationship$ref = any;
export type PdpRespSidebarBlurbs_vipUserRelationship = {
    readonly " $fragmentRefs": PdpSharedBlurbPcs_vipUserRelationship$ref;
    readonly " $refType": PdpRespSidebarBlurbs_vipUserRelationship$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_vipUserRelationship",
      "args": null
    }
  ]
};
(node as any).hash = '1cf8265b48aa8d1f45d27e1f5bfad332';
export default node;
